import React, { Component } from 'react';
import { AddStudentIcon, ApproveIcon, NotificationIconReport, ReportsIcon, FilterIcon2 } from '../svgIcons';
import GridLayout, { Responsive as ResponsiveGridLayout } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import ReactApexChart from 'react-apexcharts';
import { SelectButton } from 'primereact/selectbutton';
import { Button } from 'primereact/button';
import withRouter from '../lib/withRouter';
import Authentication from '../../session';
import { connect } from 'react-redux';
import BranchToClassDD from "../BaseDropdownComponents/BranchToClassDD";
import { baseUrlAdmin } from '../../store/apiConstants';
import Service from '../../services';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import './sisDashboard.scss';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';

class SISDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      absenteeData: [],
      showAbsentDialog: false,
      selectedAbsentData: null,
      selectedDate: new Date(),
      showCalendar: false,
      noRecordsFound: false,
      studentOverviewOptions: {
        chart: {
          type: 'bar',
          height: 350,
          toolbar: { show: false },
          stacked: false
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '12px',
            borderRadius: 2,
            distributed: false,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: { enabled: false },
        stroke: { width: 1 },
        grid: {
          borderColor: "#E5E5EF",
          strokeDashArray: 5
        },
        xaxis: {
          categories: [],
          labels: {
            rotate: -45,
            style: {
              fontSize: '12px'
            }
          }
        },
        yaxis: {
          max: 70,
          min: 0,
          tickAmount: 5,
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            }
          }
        }
      },
      studentTypeOptions: {
        chart: {
          type: 'pie',
          height: 350
        },
        colors: ['#4A3AFF', '#962DFF', '#93AAFD'],
        legend: {
          position: 'bottom',
          fontSize: '14px',
          fontFamily: 'InterRegular',
          labels: {
            colors: '#1E1B39'
          },
          markers: {
            width: 12,
            height: 12,
            radius: 6
          },
          itemMargin: {
            horizontal: 10,
            vertical: 5
          }
        },
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -5
            }
          }
        },
        dataLabels: {
          formatter(val, opts) {
            return `${opts.w.globals.series[opts.seriesIndex]}%`
          },
          style: {
            fontSize: '12px',
            fontFamily: 'InterRegular'
          }
        },
        tooltip: {
          enabled: true,
          theme: 'dark',
          fillSeriesColor: false,
          style: {
            fontSize: '12px',
            fontFamily: 'Inter'
          },
          custom: function ({ series, seriesIndex, w }) {
            return `<div class="custom-tooltip">
              <span>${w.config.labels[seriesIndex]}: ${series[seriesIndex]}%</span>
            </div>`;
          }
        }
      },
      containerWidth: 0,
      layouts: [
        { i: 'overview-chart', x: 0, y: 0, w: 12, h: 5, minW: 6, maxW: 12, minH: 4 },
        { i: 'type-chart', x: 0, y: 5, w: 4, h: 5, minW: 4, maxW: 12, minH: 4 },
        { i: 'attendance-chart', x: 5, y: 10, w: 8, h: 5, minW: 6, maxW: 12, minH: 4 }
      ],
      isDragging: false,
      selectedPeriods: {
        'attendance-chart': 'daily'
      },
      periodOptions: [
        { label: 'Daily', value: 'daily' },
        { label: 'Weekly', value: 'weekly' },
        { label: 'Monthly', value: 'monthly' }
      ],
      attendanceChartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          toolbar: { show: false },
          stacked: false
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '12px',
            borderRadius: 5,
            distributed: false
          }
        },
        colors: ['#4A3AFF'],
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        grid: {
          borderColor: "#E5E5EF",
          strokeDashArray: 5,
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        xaxis: {
          categories: ['No Data'],
          labels: {
            style: {
              fontSize: '12px',
              fontFamily: 'InterRegular'
            }
          }
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 5,
          labels: {
            formatter: function (val) {
              return val + '%';
            },
            style: {
              fontSize: '12px',
              fontFamily: 'InterRegular'
            }
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + '%';
            }
          }
        }
      },
      attendanceChartData: [{
        name: 'Attendance',
        data: []
      }],
      dropdownsData: {
        branchId: null, // Initialize as null to show org level data
        boardId: null,
        classId: null
      },
      filteredData: null,
      isLoading: false,
      chartData: {
        daily: { data: [], categories: [] },
        weekly: { data: [], categories: [] },
        monthly: { data: [], categories: [] }
      },
      showFilterDialog: false,
      savedDropdownValues: null,
      tempDropdownValues: null,
      financeData: null,
      currentLevelData: {
        summaryCards: {},
        charts: {}
      },
      selectedAttendanceData: null
    };
    this.containerRef = React.createRef();
    this.service = new Service();
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
    window.addEventListener('resize', this.handleResize);

    const defaultDropdownData = {
      branchId: null,
      boardId: null,
      classId: null
    };

    this.setState({
      dropdownsData: defaultDropdownData,
      branchInfo: this.props.branchData || []
    }, () => {
      this.fetchInitialData();
    });

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps) {
    // Fetch data when academic year becomes available
    const academicYear = localStorage.getItem("userAcademicYear");
    if (!this.state.financeData && academicYear && !this.state.isLoading) {
      this.fetchInitialData();
    }
  }

  updateDimensions = () => {
    if (this.containerRef.current) {
      const width = this.containerRef.current.offsetWidth;
      this.setState({ containerWidth: width });
    }
  };

  handleResize = () => {
    this.forceUpdate();
  };

  fetchInitialData = async () => {
    try {
      // Check if academicYear exists in localStorage before making API call
      const academicYear = localStorage.getItem("userAcademicYear");
      if (!academicYear) {
        console.warn("Academic year not available yet. Skipping API call.");
        return;
      }

      this.setState({ isLoading: true });
      const url = `${baseUrlAdmin}/sisDashboard/get-dashboard`;
      let branchInfo = [];

      // Add null check for branchData
      if (this.props.branchData && Array.isArray(this.props.branchData)) {
        branchInfo = this.props.branchData
          .filter((each) => each && each.level == 1)
          .map((each) => each.key);
      }

      const payload = {
        academicYear: academicYear,
      };

      const response = await this.service.post(url, payload, true);

      if (response.status && response.res.status) {
        const dashboardData = response.res.data.data;
        this.setState({
          financeData: dashboardData,
          dropdownsData: {
            ...this.state.dropdownsData,
            branchId: null
          }
        }, () => {
          this.onFilterData();
          this.toast.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Dashboard data loaded successfully',
            life: 3000
          });
        });
      } else {
        this.toast && this.toast.show({
          severity: 'warn',
          summary: 'Warning',
          detail: response.res.message || 'Failed to load dashboard data',
          life: 3000
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      this.toast && this.toast.show({
        severity: 'error',
        summary: 'Error',
        detail: error.message || 'Failed to fetch dashboard data. Please try again.',
        life: 3000
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  onFilterData = () => {
    const { dropdownsData, financeData } = this.state;
    if (!financeData || !financeData.dashboardData) return;

    // Default to organization level data with null safety
    let currentLevelData = {
      summaryCards: financeData.dashboardData?.summaryCards || {},
      charts: financeData.dashboardData?.charts || {}
    };

    try {
      // Only process branch/board/class data if branchId is selected
      if (dropdownsData.branchId) {
        const branch = financeData.branches?.find(b => b.branchId === dropdownsData.branchId);
        if (branch) {
          currentLevelData = {
            summaryCards: branch.branchData.summaryCards,
            charts: branch.branchData.charts
          };

          if (dropdownsData.boardId) {
            const board = branch.boards?.find(b => b.boardId === dropdownsData.boardId);
            if (board) {
              currentLevelData = {
                summaryCards: board.boardData.summaryCards,
                charts: board.boardData.charts
              };

              if (dropdownsData.classId?.length) {
                const selectedClasses = board.classes?.filter(c =>
                  dropdownsData.classId.includes(c.classId)
                );

                if (selectedClasses?.length) {
                  const aggregatedData = this.aggregateClassData(selectedClasses);
                  currentLevelData = aggregatedData;
                }
              }
            }
          }
        }
      }

      this.setState({ currentLevelData }, () => {
        this.updateAttendanceData();
        this.updateChartData();
      });

    } catch (error) {
      console.error("Error in filtering data:", error);
    }
  };

  aggregateClassData = (classes) => {
    const aggregatedData = {
      summaryCards: {
        totalStudents: 0,
        attendance: [],
        dailyAbsentee: {
          sections: []
        }
      },
      charts: {
        attendanceOverview: {
          weekly: {
            labels: classes[0]?.dashboardData?.charts?.attendanceOverview?.weekly?.labels || [],
            data: [[]],
            total: 0
          },
          monthly: {
            labels: classes[0]?.dashboardData?.charts?.attendanceOverview?.monthly?.labels || [],
            data: [[]],
            total: 0
          },
          yearly: {
            labels: classes[0]?.dashboardData?.charts?.attendanceOverview?.yearly?.labels || [],
            data: [[]],
            total: 0
          }
        },
        studentOverview: {
          grades: classes.map(classData => {
            const grade = classData.dashboardData?.charts?.studentOverview?.grades?.[0];
            if (!grade) return null;
            return {
              ...grade,
              displayName: `${grade.name}`,
              boys: grade.boys || 0,
              girls: grade.girls || 0,
              categories: grade.categories || []
            };
          }).filter(Boolean),
          yAxisMax: Math.max(...classes.map(c =>
            c.dashboardData?.charts?.studentOverview?.yAxisMax || 0
          ))
        },
        studentTypes: {
          total: 0,
          types: []
        }
      }
    };

    // Aggregate student types data from all selected classes
    const typeMap = new Map();

    classes.forEach(classData => {
      const types = classData.dashboardData?.charts?.studentTypes?.types || [];
      types.forEach(type => {
        if (!type || !type.name) return; // Skip invalid types

        const sanitizedCount = (type.count === null || type.count === undefined || isNaN(type.count)) ? 0 : Number(type.count);
        const existingType = typeMap.get(type.name);

        if (existingType) {
          existingType.count += sanitizedCount;
        } else {
          typeMap.set(type.name, { name: type.name, count: sanitizedCount });
        }
      });

      const total = classData.dashboardData?.charts?.studentTypes?.total;
      const sanitizedTotal = (total === null || total === undefined || isNaN(total)) ? 0 : Number(total);
      aggregatedData.charts.studentTypes.total += sanitizedTotal;
    });

    aggregatedData.charts.studentTypes.types = Array.from(typeMap.values());

    classes.forEach(classData => {
      const { dashboardData } = classData;
      if (!dashboardData) return;

      aggregatedData.summaryCards.totalStudents += dashboardData.summaryCards.totalStudents || 0;

      if (dashboardData.summaryCards.attendance?.length) {
        dashboardData.summaryCards.attendance.forEach(att => {
          const existingAtt = aggregatedData.summaryCards.attendance.find(
            a => a.date === att.date
          );
          if (existingAtt) {
            existingAtt.totalPresent += att.totalPresent;
            existingAtt.presentPercentage = (existingAtt.totalPresent / aggregatedData.summaryCards.totalStudents) * 100;
          } else {
            aggregatedData.summaryCards.attendance.push({ ...att });
          }
        });
      }

      if (dashboardData.summaryCards.dailyAbsentee?.sections?.length) {
        aggregatedData.summaryCards.dailyAbsentee.sections.push(
          ...dashboardData.summaryCards.dailyAbsentee.sections
        );
      }
    });

    ['weekly', 'monthly', 'yearly'].forEach(period => {
      const periodData = new Array(aggregatedData.charts.attendanceOverview[period].labels.length).fill(0);
      let count = 0;

      classes.forEach(classData => {
        const data = classData.dashboardData?.charts?.attendanceOverview?.[period]?.data[0] || [];
        if (data.length > 0) {
          count++;
          data.forEach((val, idx) => {
            // Ensure we sanitize each value to prevent null values
            const sanitizedVal = (val === null || val === undefined || isNaN(val)) ? 0 : Number(val);
            periodData[idx] = (periodData[idx] || 0) + sanitizedVal;
          });
        }
      });

      if (count > 0) {
        periodData.forEach((val, idx) => {
          // Ensure division result is also sanitized
          periodData[idx] = (val === null || val === undefined || isNaN(val)) ? 0 : (val / count);
        });
      }

      // Final sanitization of the period data array
      aggregatedData.charts.attendanceOverview[period].data[0] = periodData.map(val =>
        (val === null || val === undefined || isNaN(val)) ? 0 : Number(val)
      );
      aggregatedData.charts.attendanceOverview[period].total = periodData.reduce((a, b) => {
        const sanitizedA = (a === null || a === undefined || isNaN(a)) ? 0 : Number(a);
        const sanitizedB = (b === null || b === undefined || isNaN(b)) ? 0 : Number(b);
        return sanitizedA + sanitizedB;
      }, 0);
    });

    return aggregatedData;
  };

  updateChartData = () => {
    const { currentLevelData, selectedPeriods } = this.state;
    const currentPeriod = selectedPeriods['attendance-chart'];

    // Helper function to sanitize data arrays - replace null/undefined with 0
    const sanitizeData = (data) => {
      if (!Array.isArray(data)) return [];
      return data.map(val => (val === null || val === undefined || isNaN(val)) ? 0 : Number(val));
    };

    const newChartData = {
      daily: {
        data: sanitizeData(currentLevelData?.charts?.attendanceOverview?.daily?.data?.[0]),
        categories: currentLevelData?.charts?.attendanceOverview?.daily?.labels?.filter(Boolean) || ['No Data']
      },
      weekly: {
        data: sanitizeData(currentLevelData?.charts?.attendanceOverview?.weekly?.data?.[0]),
        categories: currentLevelData?.charts?.attendanceOverview?.weekly?.labels?.filter(Boolean) || ['No Data']
      },
      monthly: {
        data: sanitizeData(currentLevelData?.charts?.attendanceOverview?.monthly?.data?.[0]),
        categories: currentLevelData?.charts?.attendanceOverview?.monthly?.labels?.filter(Boolean) || ['No Data']
      }
    };

    // Ensure we have valid data and categories
    const currentData = sanitizeData(newChartData[currentPeriod]?.data);
    const currentCategories = newChartData[currentPeriod]?.categories?.length > 0
      ? newChartData[currentPeriod].categories
      : ['No Data'];

    this.setState({
      chartData: newChartData,
      attendanceChartData: [{
        name: 'Attendance',
        data: currentData.length > 0 ? currentData : [0]
      }],
      attendanceChartOptions: {
        ...this.state.attendanceChartOptions,
        xaxis: {
          ...this.state.attendanceChartOptions.xaxis,
          categories: currentCategories
        }
      }
    });
  };

  onLayoutChange = (layout) => {
    const sortedLayout = [...layout].sort((a, b) => a.y - b.y);
    const newLayout = sortedLayout.reduce((acc, currentItem, index) => {
      if (index === 0) {
        return [currentItem];
      }
      const prevItems = acc;
      let newPosition = { ...currentItem };
      let maxY = currentItem.y;
      prevItems.forEach(prevItem => {
        if (this.isOverlapping(prevItem, newPosition)) {
          const newY = prevItem.y + prevItem.h;
          maxY = Math.max(maxY, newY);
        }
      });
      newPosition.y = maxY;
      acc.push(newPosition);
      return acc;
    }, []);
    this.setState({ layouts: newLayout });
  };

  isOverlapping = (item1, item2) => {
    return !(
      item1.x + item1.w <= item2.x ||
      item2.x + item2.w <= item1.x ||
      item1.y + item1.h <= item2.y ||
      item2.y + item2.h <= item1.y
    );
  };

  processLayoutForOverlap = (layout) => {
    const sortedLayout = [...layout].sort((a, b) => a.y - b.y);
    return sortedLayout.map((item, index) => {
      const otherItems = sortedLayout?.slice(0, index);
      let maxY = item.y;
      otherItems.forEach(other => {
        if (this.isOverlapping(item, other)) {
          maxY = Math.max(maxY, other.y + other.h);
        }
      });
      return { ...item, y: maxY };
    });
  };

  onDragStart = (layout, oldItem, newItem, placeholder, e, element) => {
    this.setState({ isDragging: true });
    element.style.zIndex = "1000";
  };

  onDrag = (layout, oldItem, newItem, placeholder, e, element) => {
    if (!this.state.isDragging) return;

    requestAnimationFrame(() => {
      this.setState({ layouts: layout });
    });
  };

  onDragStop = (layout, oldItem, newItem, placeholder, e, element) => {
    element.style.zIndex = "1";
    this.setState({
      layouts: layout,
      isDragging: false
    });
  };

  renderDailyAbsenteeReportHeader = () => (
    <div className="flex flex-column ">
      <h4 className="chart-Title">Attendance Report</h4>
      <div className="flex flex-row justify-content-start align-items-center">
        <div className="flex align-items-center">
          <span className="chart-sub-tilte">Analysis</span>
        </div>
        <div className="flex align-items-center ml-auto">
          <div
            className="select-button-wrapper prevent-grid-drag"
            onMouseDown={e => {
              e.stopPropagation();
              e.preventDefault();
            }}
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              this.props.navigate('/studentsattendancereport');
            }}
            style={{ cursor: 'pointer', position: 'relative', zIndex: 1001 }}
          >
            <ReportsIcon />
          </div>
        </div>
      </div>
    </div>
  );

  renderAbsentDialog = () => {
    return (
      <Dialog
        visible={this.state.showAbsentDialog}
        onHide={() => this.setState({ showAbsentDialog: false })}
        header="Absent Students Details"
        style={{ width: '50vw' }}
      >
        <div>
          <h3>Class: {this.state.selectedAbsentData?.className}</h3>
          <h4>Absent Count: {this.state.selectedAbsentData?.absentCount}</h4>
        </div>
      </Dialog>
    );
  }

  renderDailyAbsenteeTable = () => {
    const absenteeData = this.state.currentLevelData?.summaryCards?.dailyAbsentee?.sections || [];
    return (
      <DataTable
        value={absenteeData}
        responsiveLayout="scroll"
        className="daily-absentee-table"
        scrollable
        scrollHeight="300px"
        style={{ width: '100%' }}
        resizableColumns
        columnResizeMode="fit"
      >
        <Column field="className" header="Grade" />
        <Column field="sectionName" header="Section" />
        <Column field='boardName' header="Board" />
        <Column field="totalStrength" header="Total Students" />
        <Column field="presentCount" header="Present Students" body={(rowData) => {
          return <span style={{ color: '#4CAF50', fontWeight: '600' }}>{rowData.presentCount}</span>
        }
        } />
        <Column field="absentCount" header="Absent Students" body={(rowData) => {
          return (
            <span
              style={{ color: '#FF0000', fontWeight: '600', cursor: 'pointer' }}
              onClick={() => this.setState({ showAbsentDialog: true, selectedAbsentData: rowData })}
            >
              {rowData.absentCount}
            </span>
          )
        }} />
      </DataTable>
    );
  }

  handleDateChange = (e) => {
    this.setState({
      selectedDate: e.value,
      showCalendar: false
    }, () => {
      this.updateAttendanceData();
    });
  }

  getMinDate = () => {
    const today = new Date();
    return new Date(today.setDate(today.getDate() - 30));
  };

  updateAttendanceData = () => {
    const { selectedDate, currentLevelData } = this.state;

    if (!currentLevelData?.summaryCards?.attendance?.length) {
      this.setState({
        selectedAttendanceData: null,
        noRecordsFound: true,
        attendanceChartData: [{ name: 'Attendance', data: [] }],
        attendanceChartOptions: {
          ...this.state.attendanceChartOptions,
          xaxis: {
            ...this.state.attendanceChartOptions.xaxis,
            categories: ['No Data']
          }
        }
      });
      return;
    }

    const selectedDateStart = new Date(selectedDate);
    selectedDateStart.setHours(0, 0, 0, 0);

    const attendanceData = currentLevelData.summaryCards.attendance.find(att => {
      const attDate = new Date(att.date);
      attDate.setHours(0, 0, 0, 0);
      return attDate.getTime() === selectedDateStart.getTime();
    });

    if (!attendanceData) {
      this.setState({
        selectedAttendanceData: null,
        noRecordsFound: true
      });
    } else {
      this.setState({
        selectedAttendanceData: attendanceData,
        noRecordsFound: false
      });
    }
  };

  renderStudentOverviewChart = () => {
    const { currentLevelData } = this.state;
    const studentOverview = currentLevelData?.charts?.studentOverview;

    // Helper function to sanitize numeric values - replace null/undefined with 0
    const sanitizeNumber = (val) => (val === null || val === undefined || isNaN(val)) ? 0 : Number(val);

    // Set default values for empty state
    const hasData = studentOverview && studentOverview.grades && studentOverview.grades.length > 0;

    const uniqueGrades = hasData ? studentOverview.grades.filter((grade, index, self) => {
      if (this.state.dropdownsData.classId?.length) {
        return true;
      }
      return index === self.findIndex((g) => g.displayName === grade.displayName);
    }) : [];

    const categoryNames = hasData ? Array.from(new Set(
      uniqueGrades.flatMap(grade =>
        grade.categories?.map(cat => cat.admissionCategoryName)
      ).filter(Boolean)
    )) : [];

    const combinedSeries = hasData && uniqueGrades.length > 0 ? [
      {
        name: 'Boys',
        data: uniqueGrades.map((grade) => sanitizeNumber(grade.boys))
      },
      {
        name: 'Girls',
        data: uniqueGrades.map((grade) => sanitizeNumber(grade.girls))
      },
      ...categoryNames.map((categoryName, categoryIndex) => ({
        name: categoryName,
        data: uniqueGrades.map(grade => {
          const categoryData = grade.categories?.find(cat => cat.admissionCategoryName === categoryName);
          return sanitizeNumber(categoryData?.count);
        })
      }))
    ].filter(series => series.data.some(value => value > 0)) : [
      { name: 'Boys', data: [0] },
      { name: 'Girls', data: [0] }
    ];

    const chartOptions = {
      ...this.state.studentOverviewOptions,
      chart: {
        ...this.state.studentOverviewOptions.chart,
        type: 'bar',
        height: '100%',
        width: '100%',
        stacked: false,
        toolbar: { show: false }
      },
      colors: [
        '#4A3AFF', '#962DFF', '#93AAFD',
        '#E0C6FD', '#7B61FF', '#B192FF',
        '#6E86FF', '#C4B5FF', '#5465FF'
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '12px',
          borderRadius: 2,
          distributed: false,
          dataLabels: {
            position: 'top',
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent']
      },
      grid: {
        borderColor: "#E5E5EF",
        strokeDashArray: 5,
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 25
        },
        yaxis: {
          lines: {
            show: true,
            min: 0
          }
        }
      },
      xaxis: {
        categories: hasData && uniqueGrades.length > 0 ? uniqueGrades.map(grade => grade.displayName || 'N/A').filter(Boolean) : ['No Data'],
        labels: {
          rotate: -45,
          style: { fontSize: '12px' },
          maxHeight: 100,
          trim: true
        },
        axisTicks: { show: true },
        axisBorder: { show: true },
        tickPlacement: 'on'
      },
      yaxis: {
        min: 0,
        max: hasData && uniqueGrades.length > 0 ? Math.max(studentOverview.yAxisMax || 0,
          Math.max(...combinedSeries.flatMap(s => s.data)) + 5) : 10,
        tickAmount: 5,
        forceNiceScale: true,
        labels: {
          formatter: val => Math.max(0, Math.round(val)),
          style: {
            fontSize: '12px',
            fontFamily: 'InterRegular'
          }
        }
      },
      tooltip: {
        y: {
          formatter: val => `${Math.round(val)}`
        }
      },
      legend: {
        show: false
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#000',
          fontSize: '14px',
          fontFamily: 'Inter',
        }
      }
    };


    return (
      <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
        <div className="chart-header">
          <div className="flex justify-content-between align-items-center">
            <h4 className="chart-Title">Student Overview Summary</h4>
            <div className="flex flex-row justify-content-start align-items-center">
              <div className="flex align-items-center">
                <div className="custom-legend flex align-items-center">
                  {combinedSeries.map((series, index) => (
                    <div key={index} className="legend-item flex align-items-center">
                      <span
                        className="legend-marker"
                        style={{
                          backgroundColor: chartOptions.colors[index],
                          width: '12px',
                          height: '12px',
                          borderRadius: '50%',
                          display: 'inline-block',
                          marginRight: '8px'
                        }}
                      ></span>
                      <span className="legend-text">{series.name}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className="flex align-items-center ml-auto reports-icon-wrapper"
                style={{
                  position: 'relative',
                  zIndex: 1005,
                  cursor: 'pointer'
                }}
                onClick={() => this.props.navigate('/studentsattendancereport')}
              >
                <ReportsIcon />
              </div>
            </div>
          </div>
        </div>
        <span className="icon-divider"></span>
        <div className="chart-body">
          <ReactApexChart
            options={chartOptions}
            series={combinedSeries}
            type="bar"
            width="100%"
            height="100%"

          />
        </div>
      </div>
    );
  };

  renderStudentTypeChart = () => {
    const { currentLevelData } = this.state;
    const studentTypes = currentLevelData?.charts?.studentTypes;

    // Helper function to sanitize numeric values - replace null/undefined with 0
    const sanitizeNumber = (val) => (val === null || val === undefined || isNaN(val)) ? 0 : Number(val);

    // Check if data is available
    const hasData = studentTypes && studentTypes.types && studentTypes.types.length > 0;

    // Calculate percentages based on total - ensure no null values
    const total = hasData ? sanitizeNumber(studentTypes.total || studentTypes.types.reduce((sum, type) => sum + sanitizeNumber(type.count), 0)) : 0;
    const series = hasData ? studentTypes.types.map(type =>
      Math.round((sanitizeNumber(type.count) / (total || 1)) * 100)
    ) : [100];
    const labels = hasData ? studentTypes.types.map(type => type.name || 'Unknown') : ['No Data'];

    const updatedOptions = {
      ...this.state.studentTypeOptions,
      chart: {
        ...this.state.studentTypeOptions.chart,
        height: '100%'
      },
      labels,
      tooltip: {
        enabled: true,
        theme: 'dark',
        fillSeriesColor: false,
        style: {
          fontSize: '12px',
          fontFamily: 'Inter'
        },
        custom: function ({ series, seriesIndex, w }) {
          if (!hasData) return '<div class="custom-tooltip"><span>No Data Available</span></div>';
          const count = studentTypes.types[seriesIndex]?.count || 0;
          const percentage = series[seriesIndex];
          return `<div class="custom-tooltip">
            <span>${w.config.labels[seriesIndex]}: ${count} (${percentage}%)</span>
          </div>`;
        }
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#000',
          fontSize: '14px',
          fontFamily: 'Inter',
        }
      }
    };

    return (
      <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
        <div className="chart-header">
          <div className="flex flex-column">
            <h4 className="chart-Title">Student Status</h4>
            <div className="flex flex-row justify-content-start align-items-center">
              <span className="chart-sub-tilte">Overview</span>
              <div className="flex align-items-center ml-auto">
                <div
                  className="select-button-wrapper prevent-grid-drag"
                  onMouseDown={e => e.stopPropagation()}
                  onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    this.props.navigate('/studentstatuschangereport');
                  }}
                >
                  <ReportsIcon />
                </div>
              </div>
            </div>
          </div>
        </div>
        <span className="icon-divider"></span>
        <div className="chart-body">
          <ReactApexChart
            options={updatedOptions}
            series={series}
            type="pie"
            width="100%"
            height="100%"
          />
        </div>
      </div>
    );
  }

  renderAttendanceOverviewHeader = (chartId) => {
    const handleChange = (e) => {
      if (e.originalEvent) {
        e.originalEvent.preventDefault();
        e.originalEvent.stopPropagation();
      }

      const newValue = e.value;
      if (newValue) {
        this.setState(prevState => ({
          selectedPeriods: {
            ...prevState.selectedPeriods,
            [chartId]: newValue
          },
          attendanceChartData: [{
            name: 'Attendance',
            data: prevState.chartData[newValue].data
          }],
          attendanceChartOptions: {
            ...prevState.attendanceChartOptions,
            xaxis: {
              ...prevState.attendanceChartOptions.xaxis,
              categories: prevState.chartData[newValue].categories
            }
          }
        }));
      }
    };

    return (
      <div className="flex flex-column" onClick={e => e.stopPropagation()}>
        <h4 className="chart-Title">Attendance Overview</h4>
        <div className="flex flex-row justify-content-start align-items-center">
          <div className="flex align-items-center">
            <span className="chart-sub-tilte">Analysis</span>
          </div>
          <div className="flex align-items-center ml-auto">
            <div
              className="select-button-wrapper"
              onMouseDown={e => e.stopPropagation()}
              onClick={e => e.stopPropagation()}
            >
              <SelectButton
                value={this.state.selectedPeriods[chartId]}
                options={this.state.periodOptions}
                onChange={handleChange}
                className="period-selector"
                optionLabel="label"
                optionValue="value"
                unselectable={false}
              />
            </div>
            <div
              className="select-button-wrapper prevent-grid-drag"
              onMouseDown={e => e.stopPropagation()}
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                this.props.navigate('/studentsattendancereport');
              }}
            >
              <ReportsIcon />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderAttendanceChart = () => {
    return (
      <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
        <div className="chart-header">
          {this.renderAttendanceOverviewHeader('attendance-chart')}
        </div>
        <span className="icon-divider"></span>
        <div className="chart-body">
          <div className="chart-flex-container">
            <div className="chart-area">
              <ReactApexChart
                options={this.state.attendanceChartOptions}
                series={this.state.attendanceChartData}
                type="bar"
                width="100%"
                height="100%"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  toggleFilterDialog = () => {
    this.setState(prev => ({
      showFilterDialog: !prev.showFilterDialog,
      savedDropdownValues: !prev.showFilterDialog ? null : prev.dropdownsData,
      tempDropdownValues: !prev.showFilterDialog ? { ...prev.dropdownsData } : null
    }));
  }

  renderFilterIcon = () => (
    <div className="filter-icon-container">
      <div className="filter-icon" onClick={this.toggleFilterDialog}>
        <div className="filter-svg">
          <FilterIcon2 color={"#fff"} />
        </div>
      </div>
      {this.state.showFilterDialog && (
        <Dialog
          visible={this.state.showFilterDialog}
          onHide={this.cancelFilters}
          draggable={false}
          style={{ width: '400px', height: 'auto' }}
          header={<h4 className='chart-Title text-center'>Filters</h4>}
          footer={
            <div className="flex justify-content-end gap-1">
              <Button
                style={{
                  marginTop: "25px",
                  marginLeft: "16px",
                  height: "44px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  background: "#E6E8EA",
                  color: "#000",
                  border: "none",
                  padding: "0 24px",
                  cursor: "pointer"
                }}
                label="Cancel"
                onClick={this.cancelFilters}
              />
              <Button
                style={{
                  marginTop: "25px",
                  marginLeft: "16px",
                  height: "44px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  background: "#076EFF",
                  color: "#fff",
                  border: "none",
                  padding: "0 24px",
                  cursor: "pointer"
                }}
                label="Apply"
                onClick={this.applyFilters}
              />
            </div>
          }
        >
          <BranchToClassDD
            setValues={this.setDropdownValues}
            rowData={this.state.rowData || { value: [] }}
            initialValues={this.state.tempDropdownValues || this.state.dropdownsData}
          />
        </Dialog>
      )}
    </div>
  );

  setDropdownValues = (dropdownsData) => {
    // If user clears branch selection, revert to org level
    const newDropdownData = {
      ...dropdownsData,
      boardId: dropdownsData.branchId ? dropdownsData.boardId : null,
      classId: dropdownsData.branchId ? dropdownsData.classId : null
    };

    this.setState({
      tempDropdownValues: newDropdownData
    });
  }

  applyFilters = () => {
    this.setState({
      dropdownsData: { ...this.state.tempDropdownValues },
      showFilterDialog: false,
      tempDropdownValues: null
    }, () => this.onFilterData());
  }

  cancelFilters = () => {
    this.setState({
      showFilterDialog: false,
      tempDropdownValues: null
    });
  }

  renderShimmerTable = () => {
    return (
      <div className="shimmer-table">
        <div className="shimmer-table-header">
          <Skeleton width="100%" height="40px" className="mb-2" />
        </div>
        <div className="shimmer-table-rows">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="shimmer-table-row" style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
              <Skeleton width="15%" height="30px" />
              <Skeleton width="15%" height="30px" />
              <Skeleton width="15%" height="30px" />
              <Skeleton width="15%" height="30px" />
              <Skeleton width="20%" height="30px" />
              <Skeleton width="20%" height="30px" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderShimmerQuickActions = () => {
    return (
      <div className="shimmer-quick-actions">
        <Skeleton width="60%" height="20px" className="mb-3" />
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
          {[...Array(3)].map((_, index) => (
            <div key={index} className="shimmer-action-item" style={{ textAlign: 'center', flex: 1 }}>
              <Skeleton width="40px" height="40px" className="mb-2" style={{ margin: '0 auto' }} />
              <Skeleton width="80%" height="15px" style={{ margin: '0 auto' }} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderShimmerAttendance = () => {
    return (
      <div className="shimmer-attendance">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
          <Skeleton width="50%" height="20px" />
          <Skeleton width="30px" height="30px" />
        </div>
        <div style={{ textAlign: 'center' }}>
          <Skeleton width="60px" height="40px" className="mb-2" style={{ margin: '0 auto' }} />
          <Skeleton width="40px" height="15px" style={{ margin: '0 auto' }} />
        </div>
      </div>
    );
  }

  renderShimmerChart = () => {
    return (
      <div className="shimmer-chart" style={{ padding: '20px' }}>
        <div className="shimmer-chart-header" style={{ marginBottom: '20px' }}>
          <Skeleton width="60%" height="25px" className="mb-2" />
          <Skeleton width="40%" height="15px" />
        </div>
        <div className="shimmer-chart-body">
          <Skeleton width="100%" height="300px" />
        </div>
      </div>
    );
  }

  renderAttendancePercentage = () => {
    const { selectedAttendanceData, currentLevelData, noRecordsFound } = this.state;

    if (noRecordsFound) {
      return (
        <div className="attendance-header">
          <h5 className="overall-per" style={{ fontSize: "14px", fontFamily: "InterRegular", color: "#000" }}>
            No records found for selected date
          </h5>
        </div>
      );
    }

    return (
      <div className="attendance-header">
        <h5 className="overall-per">
          {selectedAttendanceData?.presentPercentage?.toFixed(0) || 0}%
        </h5>
        <div className="overall-strength">
          <p>
            {selectedAttendanceData?.totalPresent || 0}/
            {currentLevelData?.summaryCards?.totalStudents || 0}
          </p>
        </div>
      </div>
    );
  };

  render() {
    const containerStyle = {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: '#E6E8EA',
      padding: window.innerWidth > 1090 ? "50px 0px 0px 95px" : "50px 0px 0px 15px",
      overflow: 'auto',
      transition: 'padding 0.3s',
      paddingBottom: '30px',
    };

    if (this.state.isLoading) {
      return (
        <div style={containerStyle}>
          <div className="sis-dashboard-wrapper">
            <div className="sis-dashboard-container">
              <div className="dashboard-main-section">
                <div className='daily-absentee-report' style={{
                  maxWidth: '100%',
                  overflow: 'hidden'
                }}>
                  <div className="daily-absentee-report-header">
                    <div className="flex flex-column">
                      <Skeleton width="250px" height="25px" className="mb-2" />
                      <Skeleton width="150px" height="15px" />
                    </div>
                    <div className="divider" style={{ margin: '15px 0' }}></div>
                    <div className="daily-absentee-report-data" style={{
                      width: '100%',
                      maxWidth: '100%',
                      overflow: 'auto',
                    }}>
                      {this.renderShimmerTable()}
                    </div>
                  </div>
                </div>
                <div className='right-section'>
                  <div className='quick-actions-container'>
                    {this.renderShimmerQuickActions()}
                  </div>
                  <div className='attendance-container'>
                    {this.renderShimmerAttendance()}
                  </div>
                </div>
              </div>
              <div ref={this.containerRef} style={{ width: '100%', marginTop: '19px' }}>
                <div className="layout" style={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: '15px' }}>
                  <div style={{ gridColumn: 'span 12' }} className="chart-container">
                    <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                      {this.renderShimmerChart()}
                    </div>
                  </div>
                  <div style={{ gridColumn: 'span 4' }} className="chart-container">
                    <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                      {this.renderShimmerChart()}
                    </div>
                  </div>
                  <div style={{ gridColumn: 'span 8' }} className="chart-container">
                    <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                      {this.renderShimmerChart()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div style={containerStyle}>
        <div className="sis-dashboard-wrapper">
          <div className="sis-dashboard-container">
            <div className="dashboard-main-section">
              <div className='daily-absentee-report' style={{
                maxWidth: '100%',
                overflow: 'hidden'
              }}>
                <div className="daily-absentee-report-header">
                  {this.renderDailyAbsenteeReportHeader()}
                  <div className="divider"></div>
                  <div className="daily-absentee-report-data" style={{
                    width: '100%',
                    maxWidth: '100%',
                    overflow: 'auto',
                  }}>
                    {this.renderDailyAbsenteeTable()}
                  </div>
                </div>
              </div>
              <div className='right-section'>
                <div className='quick-actions-container'>
                  <h5 className="quick-actions-header">Quick Actions</h5>
                  <div className="flex justify-content-between align-items-center quick-actions">
                    <div className="text-center quick-action-item" onClick={() => this.props.navigate('/studentInfo')}>
                      <AddStudentIcon className="finance-icon" />
                      <p className='quickActions-title'>Add Student</p>
                    </div>
                    <div className="text-center quick-action-item" onClick={() => this.props.navigate('/transferPendingStudents')} >
                      <ApproveIcon className="finance-icon" />
                      <p className='quickActions-title'>Approve Student Transfer</p>
                    </div>
                    <div className="text-center quick-action-item" onClick={() => this.props.navigate('/communicate-notification')}>
                      <NotificationIconReport className="finance-icon" />
                      <p className='quickActions-title'>Notify</p>
                    </div>
                  </div>
                </div>
                <div className='attendance-container '>
                  <div className="attendance-header">
                    <h5 className="quick-actions-header">Attendance %</h5>
                    <div className="calendar-wrapper">
                      <i className="pi pi-calendar calendar-icon"
                        onClick={() => this.setState({ showCalendar: !this.state.showCalendar })}
                      />
                      {this.state.showCalendar && (
                        <div className="calendar-popup">
                          <Calendar
                            value={this.state.selectedDate}
                            onChange={this.handleDateChange}
                            inline
                            showWeek={false}
                            dateFormat="dd/mm/yy"
                            maxDate={new Date()}
                            minDate={this.getMinDate()}
                            readOnlyInput
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {this.renderAttendancePercentage()}
                </div>
              </div>
            </div>
            <div ref={this.containerRef} style={{ width: '100%', marginTop: '19px' }}>
              <GridLayout
                className="layout"
                layout={this.state.layouts}
                cols={12}
                rowHeight={80}
                width={this.state.containerWidth}
                margin={[15, 15]}
                containerPadding={[0, 0]}
                isDraggable={true}
                isResizable={true}
                resizeHandles={['se']}
                onLayoutChange={this.onLayoutChange}
                compactType="vertical"
                preventCollision={false}
                verticalCompact={true}
                measureBeforeMount={true}
                onDragStart={this.onDragStart}
                onDrag={this.onDrag}
                onDragStop={this.onDragStop}
                onResizeStop={(layout) => {
                  this.onLayoutChange(layout);
                }}
                useCSSTransforms={true}
                transformScale={1}
                draggableCancel=".prevent-grid-drag,.select-button-wrapper,.period-selector"
              >
                <div key="overview-chart" className="chart-container">
                  {this.renderStudentOverviewChart()}
                </div>
                <div key="type-chart" className="chart-container">
                  {this.renderStudentTypeChart()}
                </div>
                <div key="attendance-chart" className="chart-container">
                  {this.renderAttendanceChart()}
                </div>
              </GridLayout>
            </div>
          </div>
          {this.renderAbsentDialog()}
          {this.renderFilterIcon()}
        </div>
        <Toast ref={(el) => this.toast = el} position="bottom-right" />
      </div>
    );
  }
}

const mapStatesToProps = (state) => ({
  branchData: (state.branchDataLatest &&
    state.branchDataLatest.data &&
    state.branchDataLatest.data.data &&
    Array.isArray(state.branchDataLatest.data.data))
    ? state.branchDataLatest.data.data.filter((each) => {
      return each && each.level == 1;
    }).map(each => ({ ...each }))
    : [],
})
export default connect(mapStatesToProps, {})(Authentication(withRouter(SISDashboard)));